import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../components/Form/Field'
import StartEndDateRangeFields from '../../../../../../../forms/ReusableFormFields/StartEndDateRangeFields'

import { selectedPartnershipCurrency } from '../../../../../../../modules/selectors/partnerships'

import {
  COMMUNITY_DURATION,
  COMMUNITY_INVESTMENT,
  COUNTRY_OF_OPERATION,
  EVENT_DURATION,
  EVENT_INVESTMENT,
  operationsCountriesOptions
} from '../../fields'

import useDrawerFormClasses from '../../../../../../../styles/common/drawerForms'

const GeneralInputsSection = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  const { currency_symbol: currencySymbol } = useSelector(selectedPartnershipCurrency)

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('General Inputs')}</h3>

      <FieldLabelWrapper label={t('Country of Operation')} labelFor={COUNTRY_OF_OPERATION}>
        <Field
          placeholder={t('Select Country')}
          formik={formik}
          name={COUNTRY_OF_OPERATION}
          options={operationsCountriesOptions}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Reporting Period')} labelFor={COUNTRY_OF_OPERATION}>
        <StartEndDateRangeFields formik={formik} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Event Investment')} labelFor={EVENT_INVESTMENT}>
        <Field placeholder={t('Event Investment')} formik={formik} name={EVENT_INVESTMENT} symbol={currencySymbol} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Event Duration (days)')} labelFor={EVENT_DURATION}>
        <Field placeholder={t('Event Duration')} formik={formik} name={EVENT_DURATION} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Comuntiry Investment')} labelFor={COMMUNITY_INVESTMENT}>
        <Field
          placeholder={t('Comuntiry Investment')}
          formik={formik}
          name={COMMUNITY_INVESTMENT}
          symbol={currencySymbol}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Comunity Duration (days)')} labelFor={COMMUNITY_DURATION}>
        <Field placeholder={t('Comunity Duration')} formik={formik} name={COMMUNITY_DURATION} />
      </FieldLabelWrapper>
    </section>
  )
}

export default GeneralInputsSection
